import rmskincareAPI from '../utils/rmskincareAPI';

const paymentApi = {

  getPaymentMethodCategory: async (status) => {
    let result = await rmskincareAPI.get( 'management/finance/payment/method');
    return result.data.data;
  },

  getPaymentMethodByStatus: async (statusCode,methodType) => {
    let result
    if(methodType == undefined){
      result = await rmskincareAPI.get( `management/finance/payment/method?status=${statusCode}`)
    }else{
      result = await rmskincareAPI.get( `management/finance/payment/method?status=${statusCode}&methodType=${methodType}`)
    }
    return result.data.data;
  },
  deletePaymentMethod: async (paymentId) =>{
    let result = await rmskincareAPI.delete(
      `management/finance/payment/method/del?id=${paymentId}`
    );
    return result.data.data;
  },
  createPayment: async(requestBody) => {
    let result = await rmskincareAPI.post('management/finance/payment/method/save',requestBody);
    return result.data.data;
  },
  editPayment: async(requestBody, paymentId) => {
    requestBody['id'] = paymentId;
    const result = await rmskincareAPI.post(`management/finance/payment/method/save`, requestBody);
    return result.data.data;
  },
  softDeletePayment: async(requestBody, paymentId) => {
    const result = await rmskincareAPI.post(`management/finance/payment/method/save`, requestBody);
    return result.data.data;
  }
}

export default paymentApi;
